import {defineStore} from "pinia";
import {ref} from "vue";
import {Trip} from "../models/Trip.ts";
import * as TripService from "../services/trip.service";



export const useTripsStore = defineStore('trips', () => {
    const trips = ref<Trip[]>([]);
    const trip = ref<Trip>({});
    const loading = ref(false);
    const boatsInTrips = ref([]);

    function isStatusActive(trip: Trip) {
        return trip.status === 2
    }

    function isStatusPlanned(trip: Trip) {
        return trip.status === 1
    }

    function isStatusCompleted(trip: Trip) {
        return trip.status === 3

    }

    function isStatusCancelled(trip: Trip) {

        return trip.status === 4
    }


    /**
     *
     *
     *
     *  id | sequence | mail_template_id | company_id | create_uid | write_uid |         name          | active | fold |        create_date         |         write_date         | sms_template_id
     * ----+----------+------------------+------------+------------+-----------+-----------------------+--------+------+----------------------------+----------------------------+-----------------
     *   5 |       10 |                  |            |          2 |         2 | {"en_US": "Offer"}    | t      | f    | 2024-09-25 20:25:25.892672 | 2024-09-25 20:25:27.496489 |
     *   1 |       11 |                  |            |          1 |         2 | {"en_US": "Planned"}  | t      |      | 2024-05-22 09:33:01.315765 | 2024-09-25 20:25:27.496489 |
     *   2 |       12 |                  |            |          1 |         2 | {"en_US": "Active"}   | t      |      | 2024-05-22 09:33:01.315765 | 2024-09-25 20:25:27.496489 |
     *   3 |       13 |                  |            |          1 |         2 | {"en_US": "Done"}     | t      | t    | 2024-05-22 09:33:01.315765 | 2024-09-25 20:25:27.496489 |
     *   4 |       14 |                  |            |          1 |         2 | {"en_US": "Canceled"} | t      | t    | 2024-05-22 09:33:01.315765 | 2024-09-25 20:25:27.496489 |
     * (5 rows)
     *
     */
    function getAll() {
        loading.value = true;
        TripService.getTrips().then(
            (data) => {
                console.log(data);
                // trips.value = data.data._embedded.trips;
                trips.value =
                    [
                        {
                            uuid: '123',
                            name: 'Aegean trip',
                            backgroundImageUrl: 'https://cdn.ethnos.gr/imgHandler/875/83da0b08-ac56-428f-a38e-01351dc4cce6.jpg',
                            status: 'Planned',
                            offers: []
                        },
                        {
                            uuid: '233',
                            name: 'Ionio trip',
                            backgroundImageUrl: 'https://www.greektrip.gr/wp-content/uploads/2021/03/corfu2-680x500.jpg',
                            status: 'Active',
                            offers: []
                        },
                        {
                            uuid: '41232321',
                            name: 'Kanari Islands',
                            backgroundImageUrl: 'https://www.versustravel.eu/photos/canarianislands-versustravel12.jpg',
                            status: 'Completed',
                            offers: []
                        },
                        {
                            uuid: '23121',
                            name: 'Amalfi Coast',
                            backgroundImageUrl: 'https://res.cloudinary.com/zicasso/image/fetch/c_fill,f_auto,g_auto,h_576,q_auto,w_865/https://images.zicasso.com/85976e75b77be1316b3e7924a8b16dba.jpg',
                            status: 'Cancelled',
                            offers: []
                        }
                    ]

                const allTripsBoats = new Set();
                trips.value.forEach(trip => {
                    trip.offers.forEach(boat => {
                        allTripsBoats.add(boat);
                    });
                });

                boatsInTrips.value = [...allTripsBoats];

            }).catch(error => {
            console.log(error);
            trips.value =
                [
                    {
                        uuid: '123',
                        name: 'Aegean trip',
                        backgroundImageUrl: 'https://cdn.ethnos.gr/imgHandler/875/83da0b08-ac56-428f-a38e-01351dc4cce6.jpg',
                        status: 'Planned',
                        offers: []
                    },
                    {
                        uuid: '233',
                        name: 'Ionio trip',
                        backgroundImageUrl: 'https://www.greektrip.gr/wp-content/uploads/2021/03/corfu2-680x500.jpg',
                        status: 'Active',
                        offers: []
                    },
                    {
                        uuid: '41232321',
                        name: 'Kanari Islands',
                        backgroundImageUrl: 'https://www.versustravel.eu/photos/canarianislands-versustravel12.jpg',
                        status: 'Completed',
                        offers: []
                    },
                    {
                        uuid: '23121',
                        name: 'Amalfi Coast',
                        backgroundImageUrl: 'https://res.cloudinary.com/zicasso/image/fetch/c_fill,f_auto,g_auto,h_576,q_auto,w_865/https://images.zicasso.com/85976e75b77be1316b3e7924a8b16dba.jpg',
                        status: 'Cancelled',
                        offers: []
                    }
                ]
        }).finally(() => {
            loading.value = false;
        })
    }


    function getAvailable() {
        return trips.value.filter(trip => trip.status !== 'Cancelled' && trip.status !== 'Completed')
    }

    function create(name: string, dateStart:Date, dateTo:Date): void {
        loading.value = true;
        TripService.createTrip({name: name})
            .then(() => {
                getAll()
            });

    }

    function addOffer(tripUuid: string, offerId: string): void {
        loading.value = true;

        const tripIndex = trips.value.findIndex(trip => trip.uuid === tripUuid);

        if (tripIndex !== -1) {
            if (!trips.value[tripIndex].offers.includes(offerId)) {
                trips.value[tripIndex].offers.push(offerId);
            }
            if (!boatsInTrips.value.includes(offerId)) {
                boatsInTrips.value.push(offerId);
            }

            //[tripUuid].push(offerId)
            // TripService.updateTrip(data.id, data)
            //     .then(() => {
            //         getAll()
            //     });
        } else {
            console.log(`Trip with uuid ${tripUuid} not found`);
        }
    }



    function get(uuid: string): void {
        return TripService.getTrip(uuid)
    }

    function remove(uuid: string): void {
        loading.value = true;
        TripService.deleteTrip(uuid)
            .then(() => {
                getAll()
            });
    }

    function update(uuid: string, data): void {
        loading.value = true;
        TripService.updateTrip(data.id, data)
            .then(() => {
                getAll()
            });
    }

    function hasTrips(): boolean {
        return trips.value.length > 0;
    }

    return {
        loading,
        trips,
        boatsInTrips,
        addOffer,
        getAvailable,
        hasTrips,
        getAll,
        get,
        create,
        remove,
        update,
        isStatusActive,
        isStatusPlanned,
        isStatusCompleted,
        isStatusCancelled
    }
});